import { object, ObjectSchema, string } from 'yup';

import { AddressSource, AddressSourceValue } from '@client/api';

const schema: ObjectSchema<AddressSourceValue> = object({
  integration: string<AddressSource>().required(),
  identifier: string().required()
});

export { schema as addressSourceValueSchema };
